<cb-dialog dialogHeading="{{data.name}}"
           style="height: 100%;">
    <img mat-card-image
         src="{{data.url}}"
         alt="View Image"/>
</cb-dialog>
